export const dev = {
  DB_Ads: "test_ads",
  DB_USERS: "test_users",
  STORAGE_ADS: "test_ads"
};

export const prod = {
  DB_Ads: "ads",
  DB_USERS: "users",
  STORAGE_ADS: "Ads"
};

export const config = process.env.REACT_APP_STAGE === "dev" ? dev : prod;



// WEBPACK FOOTER //
// ./src/config/config.js